import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import TabSingleTextWrapper from '../../../../common/tabSingleTextWrapper';

const Availability = forwardRef(({ data, permissions: { disableEdit } }, ref) => {
  const {
    current: { licensingAvailability, id: drugId, ingestedId },
    original: { licensingAvailability: originalData },
    ingested: {
      licensingAvailability: { data: ingestedData, fieldActions: ingestedActions },
    },
  } = useSelector(state => state.drugs, shallowEqual);
  return (
    <TabSingleTextWrapper
      disableEdit={disableEdit}
      footerData={data}
      data={licensingAvailability}
      parentKey="licensingAvailability"
      childKey="availability"
      drugId={drugId}
      ingestedId={ingestedId}
      originalData={originalData}
      ingestedData={ingestedData['availability']}
      ingestionAction={ingestedActions['availability']}
      ref={ref}
      parentIngestionAction={ingestedActions}
    />
  );
});

Availability.propTypes = {
  permissions: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isTab: PropTypes.bool.isRequired,
    tabs: PropTypes.array.isRequired,
  }),
};

Availability.displayName = 'Availability';

export default Availability;
